import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type { FC } from 'react';
import { GraphToolbarButton } from './GraphToolbarButton';

interface Props {
  disabled: boolean;
  onClick: () => PromiseLike<void> | Promise<void> | void;
}

export const GraphToolbarDebugPathlookupButton: FC<Props> = ({
  disabled,
  onClick,
}) => {
  const [loadingState, setLoadingState] = useLoadingState();

  return (
    <GraphToolbarButton
      disabled={disabled || loadingState === 'LOADING'}
      onClick={async () => {
        await withLoadingIndicator(setLoadingState)(async () => {
          await onClick();
        });
      }}
      title='Debug pathlookup'
    >
      <Icon glyph='fa-bug' loading={loadingState === 'LOADING'} />
    </GraphToolbarButton>
  );
};
